import React from "react";
import { connect } from "react-redux";
import { elementActions } from "../../../../../store/actions/cms/element/element.action";
import {
  Button,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from "reactstrap";
import { defaultEventElement } from "../../../../models/defaultElements";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";
import { deepClone } from "../../../../../helpers/objectHelper";
import { removeZerosFromNumber } from "../../../../../helpers/moneyHelpers";

class CreateEvent extends React.Component {
  state = {
    data: {
      editable: false,
      hidden: false,
      style: {},
      validation: {},
      relations: [],
      textRows: 0
    },
    eventId: 0,
    formId: 0,
    formElementId: -1,
    id: -1,
    page: 1,
    props: {
      name: "",
      startDateTime: '',
      endDateTime: '',
      description: "",
      max: 0,
      amount: 0,
      city: "",
      venue: "",
      vatPercent: 0
    },
    sortOrder: 0,
    type: 3,
    userId: 0,
    amountIncVatField: 0,

  };
  componentDidMount() {
    const { formId, eventId, mainEventStartDateTime } = this.props.form;
    this.setState({ eventId, formId, props: { ...this.state.props, startDateTime: mainEventStartDateTime, endDateTime: mainEventStartDateTime } });
  }
  handleChange(e, path) {
    const state = deepClone(this.state)
    if (path !== 'amountIncVatField') {
      const names = path.split(".");
      state[names[0]][names[1]] = e.target.value;
    }
    else {
      state.amountIncVatField = e.target.value;
    }
    this.setState(state, () => {
      if (path === 'props.vatPercent' || path === 'props.amount') {
        this.updateAmountIncVat();
      }
      if (path === 'amountIncVatField') {
        this.updateAmountExVat();
      }
    });
  }
  updateAmountIncVat = () => {
    let amount = parseFloat(this.state.props.amount);
    let vatPercent = parseInt(this.state.props.vatPercent);
    if (!isNaN(amount)) {
      let amountIncVatField = 0;
      if (isNaN(vatPercent) || vatPercent === 0) {
        amountIncVatField = removeZerosFromNumber(amount);
      }
      else {
        amountIncVatField = removeZerosFromNumber((amount + (amount * (vatPercent / 100))).toFixed(4));
      }
      this.setState({ amountIncVatField })

    }


  }
  updateAmountExVat = () => {
    let amountIncVatField = parseFloat(this.state.amountIncVatField);
    let vatPercent = parseInt(this.state.props.vatPercent);
    if (!isNaN(amountIncVatField)) {
      let amount = 0;
      if (isNaN(vatPercent) || vatPercent === 0) {
        amount = amountIncVatField
      }
      else {
        amount = (amountIncVatField / (1 + (vatPercent / 100))).toFixed(4);
      }
      const state = deepClone(this.state);
      state.props.amount = removeZerosFromNumber(amount);
      this.setState(state);
    }

  }
  create = () => {
    const { dispatch, form, action2 } = this.props;
    const { formId, eventId, mainEventStartDateTime } = this.props.form;
    let el = {
      ...defaultEventElement,
      formId: formId,
      eventId: eventId,
      languageCode: form.languageCode,
      props: { ...this.state.props },
      data: defaultEventElement.data
    };
    this.setState(el, () => {
      dispatch(elementActions.create(this.state));
      action2();
    }, () => {
      this.setState({
        data: {
          editable: false,
          hidden: false,
          style: {},
          validation: {},
          relations: [],
          textRows: 0
        },
        eventId: 0,
        formId: 0,
        formElementId: -1,
        id: -1,
        page: 1,
        props: {
          name: "",
          description: "",
          max: 0,
          amount: 0,
          city: "",
          venue: "",
          vatPercent: 0,
          startDateTime: mainEventStartDateTime, endDateTime: mainEventStartDateTime
        },
        sortOrder: 0,
        type: 3,
        userId: 0,
        amountIncVatField: 0,

      })
    });
  };


  render() {
    const { action2, form } = this.props;
    const { props } = this.state;

    return (
      <div>
        <Modal
          isOpen={this.props.isOpen}
          toggle={action2}
          className={this.props.className}
        >
          <ModalHeader toggle={this.toggle}><SystemLabel name="CreateEvent" /></ModalHeader>
          <ModalBody>
            <div>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="Name" /></Label>
                    <Input
                      autoComplete="jirango-nofill"
                      type="text"
                      value={props.name}
                      onChange={e => this.handleChange(e, "props.name")}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="12">
                  <FormGroup>
                    <Label htmlFor="description"><SystemLabel name="Description" /></Label>
                    <textarea
                      type="text"
                      className="form-control"
                      value={props.description}
                      onChange={e => this.handleChange(e, "props.description")}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="6">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="StartDate" /></Label>
                    <Input
                      autoComplete="jirango-nofill"
                      type="datetime-local"
                      defaultValue={form.mainEventStartDateTime}
                      /*      value={props.startDateTime ? props.startDateTime : form.mainEventStartDateTime} */
                      onChange={e =>
                        this.handleChange(e, "props.startDateTime")
                      }
                    />
                  </FormGroup>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="EndDate" /></Label>
                    <Input

                      type="datetime-local"
                      defaultValue={form.mainEventStartDateTime}
                      /*   value={props.startDateTime ? props.startDateTime : form.mainEventStartDateTime} */
                      onChange={e => this.handleChange(e, "props.endDateTime")}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="6">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="City" /></Label>
                    <Input
                      autoComplete="jirango-nofill"
                      type="text"
                      value={props.city}
                      onChange={e => this.handleChange(e, "props.city")}
                    />
                  </FormGroup>
                </Col>
                <Col xs="6">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="Venue" /></Label>
                    <Input
                      type="text"
                      value={props.venue}
                      onChange={e => this.handleChange(e, "props.venue")}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col xs="3">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="MaxPart" /></Label>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      className="number-w-textfacade"
                      value={props.max}
                      onChange={e => this.handleChange(e, "props.max")}
                    />
                  </FormGroup>
                </Col>
                <Col xs="3">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="Price" /></Label>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      className="number-w-textfacade"
                      value={props.amount}
                      onChange={e => this.handleChange(e, "props.amount")}
                    />
                  </FormGroup>
                </Col>
                <Col xs="3">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="PriceIncVat" /></Label>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      className="number-w-textfacade"
                      value={this.state.amountIncVatField}
                      onChange={e => this.handleChange(e, "amountIncVatField")}
                    />
                  </FormGroup>
                </Col>
                <Col xs="3">
                  <FormGroup>
                    <Label htmlFor="label"><SystemLabel name="VatPercent" /></Label>
                    <Input
                      autoComplete="jirango-nofill"
                      type="number"
                      className="number-w-textfacade"
                      value={props.vatPercent}
                      onChange={e => this.handleChange(e, "props.vatPercent")}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={this.create}>
              <SystemLabel name="Create" />
            </Button>{" "}
            <Button color="secondary" onClick={action2}>
              <SystemLabel name="Cancel" />
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    event: state.event
  };
}

export default connect(mapStateToProps)(CreateEvent);
